// extracted by mini-css-extract-plugin
export default {"project":"Project_project__cxXVv","info":"Project_info__58tn1","description":"Project_description__kZb4B","links":"Project_links__6yJj4","image":"Project_image__DVbXw"};